import React, { useState } from "react";
import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";

function ToUpperCase() {
  const [changeup, setChangeup] = useState("");
  const [copy, setCopy] = useState(false);
  const [text, setText] = useState("");
  const [errors, setErrors] = useState("");

  const handleOnErase = () => {
    setText("");
    setChangeup("");
    setCopy(false);
  };

  const handleOnChange = (event) => {
    setErrors("");
    setCopy(false);
    setText(event.target.value);

    setChangeup("");
  };

  const handleUpClick = () => {
    if (!text || text.trim() === "") return setErrors("* Please enter text.");
    let newText = text.toUpperCase();
    setChangeup(newText);
    setCopy(false);
  };

  return (
    <>
      <div className="main-globally-counter-box">
        {text?.length > 0 && (
          <div className="color-picker-icon">
            <i
              className="fa-solid fa-eraser"
              title="Clear"
              onClick={handleOnErase}
            ></i>
          </div>
        )}
        <div className="counter-text-area">
          <textarea
            className={errors && "error-input"}
            placeholder="Enter lowercase text"
            value={text}
            onChange={handleOnChange}
          />
          <span>{errors}</span>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button onClick={handleUpClick}>Convert To Uppercase</button>
      </div>
      {changeup?.length > 0 && (
        <div className="main-globally-counter-box">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(changeup)} />
            {copy && changeup && (
              <div>
                {" "}
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="counter-text-area">
            <textarea value={changeup} className="text-black" readOnly />
          </div>
        </div>
      )}
    </>
  );
}
export default ToUpperCase;
